/* eslint-disable prefer-destructuring */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { MdKeyboardArrowUp } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';
import './AppFooter.scss';
import { getIpAddressApi } from '../../../api/profileApi';
import {
  isEmpty,
  isMobileWidth,
  scrollToTop,
} from '../../helper-utils/appUtils';
import AppButton from '../app-button/AppButton';
import AppIconButton from '../app-icon-button/AppIconButton';
import { useAppContext } from '../../../saas/AppConfigWrapper';

function AppFooter() {
  const { appConfig } = useAppContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [userIpAddress, setUserIpAddress] = useState(null);
  const getIpAddress = async () => {
    if (!isMobileWidth()) {
      const res = await getIpAddressApi();
      if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
        const { Result } = res.ApiStatus;
        let ip = Result.split(',')[1];
        if (ip === null || ip === undefined || ip === '') {
          ip = Result.split(',')[0];
        }
        setUserIpAddress(ip);
        localStorage.setItem('Ipaddress', ip);
      }
    }
  };
  const shouldHideFooter =
    appConfig?.hideFooterinsearch && location.pathname !== '/login';
  useEffect(() => {
    getIpAddress();
  }, []);

  return (
    <div className="position-relative">
      {!shouldHideFooter && (
        <footer className="app-footer px-5">
          {!isMobileWidth() && (
            <AppIconButton
              className="rounded-scroll-tp-top-btn"
              variant="outlined"
              onClick={scrollToTop}
            >
              <MdKeyboardArrowUp />
            </AppIconButton>
          )}
          <div className="app-footer_container py-3 d-flex justify-content-between flex-sm-row flex-column px-sm-0 px-3">
            <div className="d-flex gap-1 flex-sm-row flex-column">
              {appConfig?.copyrightDisclaimer ? (
                <span style={{ color: 'GrayText' }}>
                  {appConfig?.copyrightDisclaimer}
                </span>
              ) : (
                <span style={{ color: 'GrayText' }}>
                  © 2025 {appConfig?.companyName}. All brands are trademarks of
                  their respective owners.
                </span>
              )}
            </div>
            <div className="d-flex gap-1 align-items-center justify-content-sm-end justify-content-center mt-sm-0 mt-2 flex-sm-row flex-column">
              <div className="d-flex gap-1 align-items-center">
                <span
                  onClick={() => navigate('/privacy-policy')}
                  className="cursor-pointer"
                >
                  <FormattedMessage id="privacy_policy" />
                </span>
                <span className="hide-in-mobile">|</span>
                <span
                  onClick={() => navigate('/terms-conditions')}
                  className="cursor-pointer"
                >
                  <FormattedMessage id="terms_conditions" />
                </span>
              </div>
              <span className="hide-in-mobile">|</span>
              <div className="d-flex gap-1 align-items-center">
                <span
                  onClick={() => navigate('/about-us')}
                  className="cursor-pointer"
                >
                  <FormattedMessage id="about_us" />
                </span>
                <span className="hide-in-mobile">|</span>
                <span
                  onClick={() => {
                    if (appConfig?.companyName === 'Aman Travels') {
                      window.open(
                        'https://onetmc.com/contact-us.html#',
                        '_blank',
                      );
                    } else {
                      navigate('/contact-us');
                    }
                  }}
                  className="cursor-pointer"
                >
                  <FormattedMessage id="contact_us" />
                </span>
                {/* <span className="hide-in-mobile">|</span>
              <span
                onClick={() => navigate('/our-values')}
                className="cursor-pointer"
              >
                <FormattedMessage id="our_values" />
              </span> */}
              </div>
            </div>
          </div>
          {!isEmpty(userIpAddress) && !isMobileWidth() && (
            <div className="app-footer_ip-address">
              Your IP is: {userIpAddress}
            </div>
          )}
        </footer>
      )}
    </div>
  );
}

export default AppFooter;
